import React from 'react'
import { ActiveSearchFilters } from './Filter/ActiveSearchFilters'
import { Divider } from '@enterprise-ui/canvas-ui-react'
import { useCaseSearch } from './SearchContext/CaseSearchProvider'
import { buildUrl, filterUser, removeFilter } from './SearchContext/SearchUtils'

import { Filter } from './Filter'
import { useLocation, useNavigate } from 'react-router-dom'
import { useProfile } from '../../Layout/UserProfile/UserProfileProvider'

export const CaseSideFilter = () => {
  const [state] = useCaseSearch()
  const navigate = useNavigate()
  const location = useLocation()
  const { userProfile } = useProfile()
  const handleChange = (
    id: string,
    type: string,
    event: any,
    searchField?: string,
  ) => {
    navigate(
      '/cases?' +
        buildUrl(location, {
          filter: id,
          event: event,
          type: type,
          searchField: searchField,
        }),
    )
  }

  const handleRemoveFilter = (
    filter: string,
    id: string | number,
    type: string,
    searchFilter?: string,
  ) => {
    navigate(
      '/cases?' +
        removeFilter(location, {
          filter: filter,
          id: id,
          type: type,
          searchFilter: searchFilter,
        }),
    )
  }

  const handleClearFilters = () => {
    navigate('/cases')
  }

  return (
    <React.Fragment>
      <ActiveSearchFilters
        searchFilters={state.searchFilters}
        sideFilters={state.sideFilters}
        handleClearSingleFilter={handleRemoveFilter}
        handleClearFilters={handleClearFilters}
        vendor={userProfile?.isVendor}
      />
      {state.sideFilters
        .filter((key) => filterUser(key, userProfile?.isVendor))
        .map((key) => (
          <React.Fragment key={key.id}>
            <Filter
              id={key.id}
              label={key.displayName}
              filters={key.values}
              onUpdate={handleChange}
              type={key.type}
              active={key.active}
              searchFields={key.searchFields}
              startExpanded={key.startExpanded}
            />
            <Divider></Divider>
          </React.Fragment>
        ))}
    </React.Fragment>
  )
}
